/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useAuth } from "../../../context/Auth/AuthProvider";
import { USER_PERMISSIONS } from "../../../roles/types/enums";
import { NAVIGATION_ITEMS, ROUTES } from "../../../shared";
import { useReleaseFeatureToggle } from "../../../shared/featureToggles/hooks";
import { FEATURE_NAMES } from "../../../shared/featureToggles/types";
import { LayoutType, isItemVisible } from "../../../shared/layout";
import { useStyles } from "../styles";

import LinkItem from "./components/LinkItem";

const Navigation = () => {
  const { isReleaseFeatureEnabledForRole } = useReleaseFeatureToggle();

  const { getAccessStatus, user } = useAuth();

  const { navigationItems } = useStyles();

  const isAllowedToSeeDashboard = isReleaseFeatureEnabledForRole(
    FEATURE_NAMES.ShowDashboard,
    user?.role
  );

  const isIntegrationsEnabled = isReleaseFeatureEnabledForRole(
    FEATURE_NAMES.ShowIntegrationsPage,
    user?.role
  );

  const LAYOUT: LayoutType[] = [
    {
      key: NAVIGATION_ITEMS.Dashboard,
      title: NAVIGATION_ITEMS.Dashboard,
      pathname: ROUTES.Dashboard,
      shouldBeVisible: isItemVisible(
        NAVIGATION_ITEMS.Dashboard,
        isAllowedToSeeDashboard
      )
    },
    {
      key: NAVIGATION_ITEMS.Vehicles,
      title: NAVIGATION_ITEMS.Vehicles,
      pathname: ROUTES.Vehicles,
      shouldBeVisible: isItemVisible(NAVIGATION_ITEMS.Vehicles)
    },
    {
      key: NAVIGATION_ITEMS.Drivers,
      title: NAVIGATION_ITEMS.Drivers,
      pathname: ROUTES.Drivers,
      shouldBeVisible: isItemVisible(NAVIGATION_ITEMS.Drivers)
    },
    {
      key: NAVIGATION_ITEMS.Files,
      title: NAVIGATION_ITEMS.Files,
      pathname: ROUTES.VehicleFiles,
      shouldBeVisible: isItemVisible(NAVIGATION_ITEMS.Files)
    },
    {
      key: NAVIGATION_ITEMS.Companies,
      title: NAVIGATION_ITEMS.Companies,
      pathname: ROUTES.Companies,
      shouldBeVisible:
        isItemVisible(NAVIGATION_ITEMS.Companies) &&
        getAccessStatus(USER_PERMISSIONS.SeeCompanyHierarchy)
    },
    {
      key: NAVIGATION_ITEMS.Users,
      title: NAVIGATION_ITEMS.Users,
      pathname: ROUTES.Users,
      shouldBeVisible:
        isItemVisible(NAVIGATION_ITEMS.Users) &&
        getAccessStatus(USER_PERMISSIONS.ManageUsers)
    },
    {
      key: NAVIGATION_ITEMS.Integrations,
      title: NAVIGATION_ITEMS.Integrations,
      pathname: ROUTES.Integrations,
      shouldBeVisible: isItemVisible(
        NAVIGATION_ITEMS.Integrations,
        isIntegrationsEnabled
      )
    }
  ];

  const linkItems = LAYOUT.map(
    (layoutItem: LayoutType) =>
      layoutItem.shouldBeVisible && (
        <LinkItem
          key={layoutItem.key}
          name={layoutItem.title}
          link={layoutItem.pathname}
        />
      )
  );

  return (
    <nav data-testid="navigation">
      <ul css={css(navigationItems)}>{linkItems}</ul>
    </nav>
  );
};

export default Navigation;
